import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IResetPasswordForm } from 'src/app/interfaces';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent {
  constructor(public usersService: UsersService, private snackBar: MatSnackBar) { }

  resetPasswordForm: IResetPasswordForm = {
    email: '',
  }

  resetPassword(){
    this.usersService.resetPassword(this.resetPasswordForm).subscribe(
      () => {
        this.snackBar.open("Um e-mail foi enviado com as instruçōes para configurar a nova senha", "Fechar", {
          duration: 7000,
        })
      },
      error => {
        console.log('error: ', error);
        this.snackBar.open("Não foi possível resetar a senha, tente novamente mais tarde", "Fechar", {
          duration: 7000,
        })
      });
  }
}
